import { render, staticRenderFns } from "./matter.vue?vue&type=template&id=635c7e5a&scoped=true&"
import script from "./matter.vue?vue&type=script&lang=js&"
export * from "./matter.vue?vue&type=script&lang=js&"
import style0 from "./matter.vue?vue&type=style&index=0&id=635c7e5a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "635c7e5a",
  null
  
)

export default component.exports